import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-delete-text"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createStaticVNode("<g class=\"\"><circle cx=\"22\" cy=\"22\" r=\"10\" class=\"icon-fi--background-fill icon-fi--filled\"></circle><g transform=\"translate(-5.116 -5.116)\" class=\"\"><line x1=\"31.1\" x2=\"23.1\" y1=\"23.1\" y2=\"31.1\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line><line x1=\"23.1\" x2=\"31.1\" y1=\"23.1\" y2=\"31.1\" class=\"icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke\"></line></g></g>", 1)
  ]), 16))
}
export default { render: render }